export default class objBg {
    constructor() {
        this.character = 'allen'
        this.characterid = 0
        this.bestimgnum = '4'
        this.bestimgid = '1'
    }

}